import React, { useCallback,useEffect, useState,useRef } from 'react'
import {Table,Row,Col, Typography,Button,Space,Modal,message, Input,notification,Tag,Select } from 'antd'
import CenterService from '../../services/CenterService';
import CampusService from '../../services/CampusService';
import { Link } from "react-router-dom";
import {EditOutlined,DeleteOutlined,SnippetsOutlined,SearchOutlined} from '@ant-design/icons';
import { selectInstituteInformation } from '../../Auth/instituteInformationReducer';
import { useSelector } from 'react-redux';
import { selectUser } from '../../Auth/userReducer';
import InstituteService from '../../services/InstituteService';


var verificationResult=[];


const {Title,Text} = Typography;

const optionsFilterCenter=[{
  label: "Centros sin institutos",
  value: false,
},{
  label: "Centros con institutos",
  value: true,
}]
const RolesPermited=[
  "ANIDI - Director",
]

export default function Center(props) {
  const {InstituteID}=props
  const user= useSelector(selectUser)

  const [stateModal, setStateModal]=useState({visible:false});
  const [centerTarget, setCenterTarget] = useState({ title: "",id:0 });
  const [centers, setCenters]=useState([]);
  const [listCampusOptions,setListCampusOptions]=useState([])
  const [loadingTable,setLoadingTable]=useState(true)
  const institute=useSelector(selectInstituteInformation)
  
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  
  const keyU = 'updatable';
  const [api, contextHolder] = notification.useNotification();

  const [permissionByRol,setPermissionByRol]=useState(false)
  const [listInstitutes,setListInstitutes]=useState([])
  const [instituteSelected,setInstituteSelected]=useState()
  const [optCenterSelected,setOptCenterSelected]=useState()
  const [viewOptInstituteSelected,setViewOptInstituteSelected]=useState()
  const [needRealodTable,setNeedRealodTable]=useState(false)
  
  
  const setOptsView=(value)=>{
    setOptCenterSelected(value)
    console.log("value",value)
    if(value){
      setViewOptInstituteSelected(true)
    }
    else{
      setViewOptInstituteSelected(false)
    }
  }
  
  const getAllCenters= useCallback((InstituteKey)=>{
      CenterService.getListCentersByInstitute(InstituteKey)
      .then((res)=>{
        if(res?.data?.success){
          setCenters(res.data.response)
          setLoadingTable(false)
        }
        else{
          console.error("No se pudo obtener el listado de los centros")
          message.error("No se pudo obtener el listado de los centros")
        }
        
      })
  },[]);

  const getAllCentersWithoutInstitutes= useCallback(()=>{
    CenterService.getAllCentersWithoutInstitute()
    .then((res)=>{
      if(res?.data?.success){
        console.log("Obtención del listado de centros sin institutos exitoso")
        setCenters(res.data.response)
        setLoadingTable(false)
      }
      else{
        console.error("No se pudo obtener el listado de los centros")
        message.error("No se pudo obtener el listado de los centros")
      }
      
    })
},[]);

  const getListInstitutes= useCallback(()=>{
    InstituteService.getAllInstitutes()
    .then((res)=>{
      if(res?.data?.success){
        let ListInstitutes=res.data?.response || []
        ListInstitutes=ListInstitutes.map((Insitute)=>{
          return {
            label: `${Insitute.acronym} - ${Insitute.name}`,
            value: Insitute.id,
          }
        })
        console.log("Obtención del listado de institutos exitoso")
        setListInstitutes(ListInstitutes)
        setLoadingTable(false)
      }
      else{
        console.error("No se pudo obtener el listado de los institutos")
        message.error("No se pudo obtener el listado de los institutos")
      }
      
    })
},[]);

  const getListCampus=useCallback(()=>{
    CampusService.getlistCampus().then((res)=>{
      if(res?.data?.success){
        setListCampusOptions(res?.data?.response)
      }
      else{
        console.error("No se pudo obtener el listado de los sedes")
        message.error("No se pudo obtener el listado de los sedes")
      }
    })
  })


  const showModal = (record) => {
    setCenterTarget({ title: record.name, id:record.id });
    setStateModal({
      visible: true,
    });
  };

  const hideModal = () => {
    setStateModal({
      visible: false,
    });
  };
  

  const checkDataByCenter=async(centerTargetId)=>{
    var centerTargetNow= await CenterService.checkDataByCenterForDeleted(centerTargetId).then(value=>{
      return value?.data?.response
    })
    let res={
      Coordinador:centerTargetNow.Coordinador.User===null? true:false,
      Usuarios:centerTargetNow.Usuarios.count===0? true:false,
      Lineas:centerTargetNow.Lineas.count===0? true:false,
    }
    
    return res;
  }


  const descriptionVerification=()=>{
    let verificationDescription=
      <Space direction='vertical'>
          {verificationResult.Coordinador? <Tag  color="success"> No se tiene asignado un coordinador</Tag>:
        <Tag  key={"coordinadorerror"} color="error">Se tiene asignado aun un coordinador</Tag>}
          {verificationResult.Lineas? <Tag  color="success"> No se tiene asignado lineas</Tag>:
        <Tag  key={"lineaserror"} color="error">Se tiene asignado aun lineas</Tag>}
          { verificationResult.Usuarios? <Tag  color="success"> No se tiene asignado usuarios</Tag>:
        <Tag  key={"usuarioserror"} color="error">Se tiene asignado aun usuarios</Tag>}
      </Space>;
    return(verificationDescription)
  }

  
  const openNotification = () => {
    api.open({
      keyU,
      message: `No se puede eliminar el ${centerTarget.title } por los siguientes motivo: `,
      description: descriptionVerification(),
    });
  };

  const onAceptModal=async()=>{
    verificationResult= await checkDataByCenter(centerTarget.id)
    if(verificationResult.Coordinador && verificationResult.Usuarios && verificationResult.Lineas){
      CenterService.deleteCenterById(centerTarget.id)
      .then((res)=>{
        if(res.data?.success){
          message.success('Se elimino correctamente el centro',3);
          setNeedRealodTable(true)
        }
        else{
          message.error("No se pudo eliminar el centro")
        }
        hideModal()
      }); 
    }
    else{
      openNotification()
    }
  }

  const verificityPermissionRol=()=>{
    let res=RolesPermited.includes(user.rolName)
    setPermissionByRol(res)
  }

  const assignInstituteID=()=>{
    let idInst
    if(user.rolName==="Coordinador del instituto"){
      idInst=institute.id
    }
    else if(user.rolName==="ANIDI - Director"){
      InstituteID===null?
        idInst=InstituteID
        :
        idInst=instituteSelected
    }
    setInstituteSelected(idInst)
    return idInst
  }

  const getDataForEachOption=useCallback(()=>{
    if(permissionByRol){
      if(viewOptInstituteSelected){
        getListInstitutes()
        assignInstituteID()
        getAllCenters(instituteSelected);
      }else{
        getAllCentersWithoutInstitutes()
      } 
    }
    else{
      assignInstituteID()
    }
  })
  
  useEffect(()=>{
    assignInstituteID()
    verificityPermissionRol();
    getListCampus();
  },[])

  

  useEffect(()=>{
    getAllCenters(instituteSelected)
    setNeedRealodTable(false)
  },[instituteSelected,needRealodTable])

  useEffect(()=>{
    getDataForEachOption()
  },[viewOptInstituteSelected])


  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex,title) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Buscar por ${title}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reestablecer
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filtrar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Cerrar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    
  });

  

  const columns = [
    {
      title: 'Nombre',
      width:"15%",
      dataIndex: 'name',
      key: 'name',
      fixed: 'left',
      ...getColumnSearchProps('name','nombre'),
      render:(text)=><Text  style={ {
              width: "100%" ,
            }
      }
      ellipsis={{
              tooltip: {text},
            }
      }>{text}</Text>
    },
    {
      title:'Sigla',
      dataIndex:'acronym',
      key: 'acronym',
      ...getColumnSearchProps('acronym','sigla'),
    },
    {
      title:"Sede academica",
      dataIndex:"campusId",
      key: "campusId",
      render: (i,record)=>{
        const rowDataCampus=record?.Campus?.name;
        return <Text  style={ {
          width: "100%" ,
        }}
        ellipsis={{tooltip: {rowDataCampus}}}>
          {rowDataCampus}
        </Text>
      },
      
      //filters: filterListCampus(),
      //onFilter: (value, record) => record.Campus.name.startsWith(value),
      //filterSearch: true,
    },
    {
      title:"Unidad academica",
      dataIndex:"academicUnitId",
      key: "academicUnitId",
      render: (i,record)=>{
        const rowDataUA=record?.AcademicUnit?.name;
        return <Text  style={ {
          width: "100%" ,
        }}
        ellipsis={{tooltip: {rowDataUA}}}>
          {rowDataUA}
        </Text>
      }
    },
    {
      title:"Coordinador",
      dataIndex:"coordinatorId",
      key:"coordinatorId",
      render: (i,record)=>{
        const rowDataCoo= record?.User?.firstName+' '+record?.User?.lastName;
        return <Text  style={ {
          width: "100%" ,
        }}
        ellipsis={{tooltip: {rowDataCoo}}}>
          {rowDataCoo}
        </Text>
      }
    },
    {
      title:"Opciones",
      width:"15%",
      dataIndex:"",
      key: "optionsForm",
      render:(_, record) => (
        <Space size="large" align='center'>
          <Link style={{display:"flex", flexDirection:"column"}} to={"/center/detail/"+record.id}>
          <SnippetsOutlined>
          </SnippetsOutlined>
          <Text>Ver</Text>
          </Link>
          <Link style={{display:"flex", flexDirection:"column"}} to={"/center/form/"+ record.id}>
            <EditOutlined> 
            </EditOutlined>
            <Text>Editar</Text>
          </Link >
          <Link style={{display:"flex", flexDirection:"column"}} onClick={()=>showModal(record)}>
            <DeleteOutlined>
            </DeleteOutlined>
            <Text>Eliminar</Text>
          </Link>
        </Space>
      ),
      fixed:"right"
    },
  ];
  


  return (
      <>
      <Row align="center" style={{ marginTop: "25px" }}>
        <Col
          xs={{ span: 20 }}
          sm={{ span: 16 }}
          md={{ span: 16 }}
          lg={{ span: 16 }}
          xl={{ span: 16 }}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Title >Centros</Title>
        </Col>
      </Row>
      <Row  align="end" style={{ marginTop: "25px", marginRight: 45 ,alignContent: "center"}}>
        <Space>
         { permissionByRol && (
         <Select 
         placeholder="Opción para filtrar"
         style={{width: 200}}
         options={optionsFilterCenter}
         onChange={setOptsView}
         value={optCenterSelected}
         >
         </Select>
         )}
          {(viewOptInstituteSelected) && (
         <Select 
         placeholder="Seleccione un instituto"
         style={{width: 200}}
         options={listInstitutes}
         value={instituteSelected}
         onChange={setInstituteSelected}
         >
         </Select>
         )}
          <Link to="/center/form/">
            <Button
              type="primary" 
              style={{
                marginRight:"4%",
                marginBottom: 16,
                float: "right",
              }}
            >
              Agregar Centros
            </Button>
          </Link>
        </Space>
      </Row>
      <Table 
        loading={loadingTable}
        style={{ 
          marginLeft: "50px", 
          marginRight: "50px", 
          borderRadius:"3%",
        }}
        columns={columns} 
        dataSource={centers} 
        rowKey="id"
        //pagination={{showSizeChanger: true}}//pagination={{ pageSize: 10, total: 5, showSizeChanger: true }} 
        scroll={{
          x: 1300,
        }}
      >

    </Table>
    {contextHolder}
      <Modal
        title={`Eliminar el centro '${centerTarget.title}'`}
        open={stateModal.visible}
        onOk={onAceptModal}
        onCancel={hideModal}
        okText="Aceptar"
        cancelText="Cancelar"
        >
          <p>¿Esta seguro que desea eliminar el centro?</p>
        </Modal>
    </>
  )
}
